import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {UserGranredAuthorityName} from "../router/const/AllPermitions";
import {RedirectModuleName, RedirectServiceModuleName, UserServiceModuleName} from "../utils/names/optionalModuleNames";
import {
    AngularJsMaterialModuleName,
    LoaderModuleName,
    MainServiceModuleName
} from "../utils/names/requiredModulesNames";
import {NavigationAccessRoles, NavigationItem} from "../main/model/navigationItem";
import {getTabName} from "modules/utils/TabNameUtils";

export const RedirectModule = new RestrictedRouteModuleConfiguration(
    UserGranredAuthorityName.REDIRECTS,
    [
        RedirectModuleName,
        LoaderModuleName,
        RedirectServiceModuleName,
        AngularJsMaterialModuleName,
        MainServiceModuleName,
        UserServiceModuleName
    ],
    [
        ["/redirect_urls", {
            template: require("./route/redirect_url.html"),
            controller: "configureRedirectsController",
            resolve: {
                redirects: ['ConfigurableRedirectService', function (ConfigurableRedirectService) {
                    return ConfigurableRedirectService.getRedirects()
                        .then(resp => {
                            return resp.data
                        });
                }]
            }
        }]
    ],
    [
        new NavigationItem({
            title: "Redirects",
            href: "#!redirect_urls",
            accessRole: [NavigationAccessRoles.ROLE_ADMIN],
            activeFunction: (routeName) => {
                return routeName.indexOf("redirect_urls") !== -1;
            }
        })
    ],
    [RedirectModuleName, RedirectServiceModuleName],
    [UserGranredAuthorityName.REDIRECTS],
    getTabName() + '| Redirects'
);

export default RedirectModule;